import {
    REMOVE_CARD_DETAILS_START,
    REMOVE_CARD_DETAILS_SUCCESS,
    REMOVE_CARD_DETAILS_ERROR
} from '../../constants';
import  showToaster  from '../../helpers/toastrMessgaes/showToaster';
import { removeCardDetails as mutation, getPaymentMethod as query } from '../../lib/graphql';

export function removeCardDetailsAction() {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: REMOVE_CARD_DETAILS_START,
            });

            const { data } = await client.mutate({
                mutation,
                refetchQueries: [{ query }]
            });

            if (data?.removeCardDetails?.status === 200) {
                await showToaster({ messageId: 'cardRemove', toasterType: 'success' });
                dispatch({
                    type: REMOVE_CARD_DETAILS_SUCCESS,
                });
            } else {
                let errorMessage = data?.removeCardDetails?.errorMessage
                showToaster({ messageId: 'catchMessage', requestContent: errorMessage, toasterType: 'error' });
                dispatch({
                    type: REMOVE_CARD_DETAILS_ERROR,
                });
            }
        } catch (error) {
            dispatch({
                type: REMOVE_CARD_DETAILS_ERROR,
            });
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}